import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const NCERTMasteryPage = () => {
  const [expandedSyllabus, setExpandedSyllabus] = useState(null);
  const [expandedSection, setExpandedSection] = useState(null);

  const syllabusData = [
    { 
      subject: 'History', 
      books: [
        'Class VI - Our Past',
        'Class VII - Our Pasts-I',
        'Class VIII - Our Pasts-III (Part 1 & 2)',
        'Class X - India and the Contemporary World-II',
        'Class XI - Themes in World History'
      ]
    },
    { 
      subject: 'Geography', 
      books: [
        'Class VI - The Earth Our Habitat',
        'Class VII - Our Environment',
        'Class IX - Contemporary India-I',
        'Class X - Contemporary India-II',
        'Class XI - Fundamentals of Physical Geography',
        'Class XII - Fundamentals of Human Geography',
        'Class XII - India - People and Economy'
      ]
    },
    { 
      subject: 'Polity', 
      books: [
        'Class VI - Social Science - Social and Political Life-I',
        'Class VII - Social Science - Social and Political Life-II',
        'Class IX - Political Science - Democratic Politics Part-I',
        'Class X - Political Science - Democratic Politics Part-II',
        'Class XI - Political Science - Indian Constitution at Work'
      ]
    },
    { 
      subject: 'Economics', 
      books: [
        'Class IX - Economics',
        'Class X - Understanding Economic Development',
        'Class XI - Indian Economic Development',
        'Class XII - Introductory Macroeconomics'
      ]
    },
    { 
      subject: 'Science', 
      books: [
        'Selected chapters from Classes VI-X Science textbooks',
        'Class XI - Chemistry (Unit 14), Biology (Units 4 & 5)'
      ]
    },
    { 
      subject: 'Environment', 
      books: [
        'Environmental chapters from Science NCERTs (Classes VI-X)',
        'Class XII Biology (Units 8, 9 & 10)'
      ]
    },
    { 
      subject: 'Sociology', 
      books: [
        'Class XI - Understanding Society',
        'Class XII - Indian Society',
        'Class XII - Social Change and Development in India'
      ]
    }
  ];

  const sectionalTests = [
    { test: 'Test 1', subject: 'Physical & Human Geography' },
    { test: 'Test 2', subject: 'Indian Geography' },
    { test: 'Test 3', subject: 'Basic Economics & Development' },
    { test: 'Test 4', subject: 'Indian Economy and Macroeconomics' },
    { test: 'Test 5', subject: 'Ancient & Medieval Indian History' },
    { test: 'Test 6', subject: 'Ancient & Medieval Indian History' },
    { test: 'Test 7', subject: 'Modern Indian History & World History' },
    { test: 'Test 8', subject: 'Indian Constitution & Political System' },
    { test: 'Test 9', subject: 'Governance & Democratic Systems' },
    { test: 'Test 10', subject: 'General science' },
    { test: 'Test 11', subject: 'Science & Technology' },
    { test: 'Test 12', subject: 'Environment & Ecology' }
  ];

  const fullLengthSubjectTests = [
    { test: 'Test 1', subject: 'Geography' },
    { test: 'Test 2', subject: 'Economy' },
    { test: 'Test 3', subject: 'History' },
    { test: 'Test 4', subject: 'Polity' },
    { test: 'Test 5', subject: 'General science and science and technology' },
    { test: 'Test 6', subject: 'Environment' }
  ];

  const fullLengthTests = [
    { test: 'FL-1', coverage: 'Complete subject' },
    { test: 'FL-2', coverage: 'Complete subject' },
    { test: 'FL-3', coverage: 'Complete subject' }
  ];

  return (
    <div>
      <Navbar />
      
      <div className="page-header">
        <div className="container">
          <h1 data-testid="page-title" style={{ color: '#00d4ff', textShadow: '2px 2px 4px rgba(0,0,0,0.5)', fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 800 }}>NCERT Foundation Test Series 2025</h1>
          <p style={{ fontSize: '1.25rem', marginTop: '1rem', color: '#ffffff', textShadow: '1px 1px 3px rgba(0,0,0,0.3)' }}>Comprehensive test series covering all NCERT books with expert analysis and doubt solving</p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginTop: '2rem' }}>
            <a 
              href="https://forms.gle/5mjmuxov7LaYCHTU6" 
              target="_blank"
              rel="noopener noreferrer"
              style={{ 
                display: 'inline-block',
                padding: '1rem 3rem',
                background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
                color: '#ffffff',
                borderRadius: '0.5rem',
                textDecoration: 'none',
                fontWeight: 700,
                fontSize: '1.25rem',
                boxShadow: '0 6px 20px rgba(255, 107, 107, 0.4)',
                transition: 'all 0.3s ease',
                border: '2px solid rgba(255, 255, 255, 0.3)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-3px) scale(1.05)';
                e.target.style.boxShadow = '0 8px 25px rgba(255, 107, 107, 0.6)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0) scale(1)';
                e.target.style.boxShadow = '0 6px 20px rgba(255, 107, 107, 0.4)';
              }}
            >
              🚀 Enroll Now
            </a>
            <a 
              href="#about" 
              style={{ 
                display: 'inline-block',
                padding: '1rem 2.5rem',
                background: '#ffffff',
                color: '#1e3a5f',
                borderRadius: '0.5rem',
                textDecoration: 'none',
                fontWeight: 600,
                fontSize: '1.125rem',
                boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
              }}
            >
              Learn More →
            </a>
          </div>
        </div>
      </div>

      <section className="py-8 container" id="about">
        <h2 style={{ marginBottom: '2rem' }}>🔍 About Our Program</h2>
        <div className="card">
          <p style={{ fontSize: '1.125rem', lineHeight: 1.8, color: 'var(--muted-foreground)' }}>
            The Adhva Academy UPSC Foundation Test Series is meticulously designed to build a strong NCERT-based foundation for UPSC aspirants. Our comprehensive 3-month program focuses exclusively on mastering the NCERT syllabus, which forms the bedrock of UPSC preparation.
          </p>
        </div>
      </section>

      <section className="py-8" style={{ background: 'var(--secondary)' }}>
        <div className="container">
          <h2 style={{ marginBottom: '2rem' }}>🌟 What Makes Us Different</h2>
          <div style={{ display: 'grid', gap: '2rem' }}>
            <div className="card" data-testid="feature-0">
              <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>1. Personalized Mentorship</h3>
              <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
                <li>One-on-one guidance from experienced UPSC mentors</li>
                <li>Regular progress monitoring and personalized feedback</li>
                <li>Strategic guidance tailored to your strengths and weaknesses</li>
                <li>Goal-setting and achievement tracking</li>
                <li>Motivation and emotional support throughout your journey</li>
              </ul>
            </div>

            <div className="card" data-testid="feature-1">
              <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>2. Doubt Solving Sessions</h3>
              <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
                <li>Weekly interactive doubt clearing sessions</li>
                <li>Small group format for personalized attention</li>
                <li>Facility to submit questions in advance</li>
                <li>Concept clarification by subject matter experts</li>
                <li>Supplementary study materials for difficult topics</li>
              </ul>
            </div>

            <div className="card" data-testid="feature-2">
              <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>3. Detailed Test Analysis</h3>
              <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
                <li>Comprehensive performance analytics after each test</li>
                <li>Question-by-question review with faculty</li>
                <li>Identification of knowledge gaps and conceptual misunderstandings</li>
                <li>Personalized improvement strategies</li>
                <li>Comparative performance metrics to track progress</li>
              </ul>
            </div>

            <div className="card" data-testid="feature-3">
              <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>4. Notes Making Process</h3>
              <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
                <li>Learn effective note-making techniques specific to UPSC</li>
                <li>Structured templates for different subjects</li>
                <li>Guidance on information organization and recall</li>
                <li>Mind-mapping and visual learning techniques</li>
                <li>Digital and traditional note-making methodologies</li>
              </ul>
            </div>

            <div className="card" data-testid="feature-4">
              <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>5. NCERT Gist</h3>
              <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
                <li>Techniques to extract Mains-relevant content from NCERTs</li>
                <li>Application of NCERT concepts to current affairs</li>
                <li>Strategies for integrating NCERT content into answer writing</li>
                <li>Development of multidimensional perspectives</li>
                <li>Example answers incorporating NCERT foundations</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 container">
        <h2 style={{ marginBottom: '2rem' }}>📚 Course Structure</h2>
        <p style={{ marginBottom: '2rem', fontSize: '1.125rem', color: 'var(--muted-foreground)' }}>
          Our UPSC Foundation Test Series consists of 11 subject-specific tests and 7 full-length tests, methodically scheduled to build your knowledge progressively.
        </p>

        {/* Subject/Sectional Tests */}
        <div className="card" style={{ marginBottom: '2rem' }}>
          <h3 style={{ marginBottom: '1.5rem', color: 'var(--primary)' }}>Subject/Sectional Tests (Sundays, 1-hour duration, 50 MCQs)</h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: 'var(--secondary)' }}>
                  <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Test</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Subject</th>
                </tr>
              </thead>
              <tbody>
                {sectionalTests.map((item, idx) => (
                  <tr key={idx} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '0.75rem' }}>{item.test}</td>
                    <td style={{ padding: '0.75rem', color: 'var(--muted-foreground)' }}>{item.subject}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Subject wise full length tests */}
        <div className="card" style={{ marginBottom: '2rem' }}>
          <h3 style={{ marginBottom: '1.5rem', color: 'var(--primary)' }}>Subject wise Full Length Test (Sundays, 2-hour duration, 100 MCQs)</h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: 'var(--secondary)' }}>
                  <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Test</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Subject</th>
                </tr>
              </thead>
              <tbody>
                {fullLengthSubjectTests.map((item, idx) => (
                  <tr key={idx} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '0.75rem' }}>{item.test}</td>
                    <td style={{ padding: '0.75rem', color: 'var(--muted-foreground)' }}>{item.subject}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Full-Length Tests */}
        <div className="card">
          <h3 style={{ marginBottom: '1.5rem', color: 'var(--primary)' }}>Full-Length Tests (2-hour duration, 100 MCQs)</h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: 'var(--secondary)' }}>
                  <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Test</th>
                  <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Coverage</th>
                </tr>
              </thead>
              <tbody>
                {fullLengthTests.map((item, idx) => (
                  <tr key={idx} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '0.75rem' }}>{item.test}</td>
                    <td style={{ padding: '0.75rem', color: 'var(--muted-foreground)' }}>{item.coverage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-8" style={{ background: 'var(--secondary)' }}>
        <div className="container">
          <h2 style={{ marginBottom: '2rem' }}>📖 NCERT Syllabus Covered</h2>
          
          <div style={{ display: 'grid', gap: '1rem' }}>
            {syllabusData.map((item, idx) => (
              <div key={idx} className="accordion-item" data-testid={`syllabus-${idx}`}>
                <div className="accordion-header" onClick={() => setExpandedSyllabus(expandedSyllabus === idx ? null : idx)}>
                  <span style={{ fontWeight: 700 }}>{item.subject}</span>
                  <span>{expandedSyllabus === idx ? '−' : '+'}</span>
                </div>
                {expandedSyllabus === idx && (
                  <div className="accordion-content">
                    <ul style={{ marginLeft: '1.5rem', lineHeight: 1.8 }}>
                      {item.books.map((book, i) => <li key={i}>{book}</li>)}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-8 container">
        <h2 style={{ marginBottom: '2rem' }}>🎯 Program Benefits</h2>
        
        <div style={{ display: 'grid', gap: '2rem' }}>
          <div className="card">
            <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>Structured Learning Path</h3>
            <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
              <li>Systematic coverage of all NCERT material</li>
              <li>Progressive difficulty level</li>
              <li>Subject-wise mastery before moving to comprehensive tests</li>
            </ul>
          </div>

          <div className="card">
            <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>Exam Simulation</h3>
            <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
              <li>Time management practice</li>
              <li>Question pattern aligned with UPSC preliminaries</li>
            </ul>
          </div>

          <div className="card">
            <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>Performance Analytics</h3>
            <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
              <li>Detailed scorecards</li>
              <li>Subject-wise performance breakdown</li>
              <li>Progress tracking over time</li>
            </ul>
          </div>

          <div className="card">
            <h3 style={{ marginBottom: '1rem', color: 'var(--primary)' }}>Holistic Development</h3>
            <ul style={{ marginLeft: '1.5rem', lineHeight: 2, color: 'var(--muted-foreground)' }}>
              <li>Content knowledge building</li>
              <li>Test-taking strategy development</li>
              <li>Stress management techniques</li>
              <li>Answer writing skills for Mains</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="py-8" style={{ background: 'var(--primary)', color: 'white' }}>
        <div className="container text-center">
          <h2 style={{ marginBottom: '2rem', color: 'white' }}>📝 Enrollment Process</h2>
          <div className="grid grid-3">
            {[
              { step: '1', title: 'Online Application', desc: 'Visit https://adhvaacademy.in/enroll' },
              { step: '2', title: 'Enrollment', desc: 'Complete registration and fee payment' },
              { step: '3', title: 'Orientation', desc: 'Introduction to the program structure and mentors' }
            ].map((item, idx) => (
              <div key={idx} style={{ textAlign: 'center' }}>
                <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'white', color: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', fontWeight: 700, margin: '0 auto 1rem' }}>{item.step}</div>
                <h3 style={{ marginBottom: '0.5rem', color: 'white' }}>{item.title}</h3>
                <p style={{ opacity: 0.9 }}>{item.desc}</p>
              </div>
            ))}
          </div>
          <a href="https://forms.gle/5mjmuxov7LaYCHTU6" target="_blank" rel="noopener noreferrer" className="btn-primary" style={{ marginTop: '3rem', background: 'white', color: 'var(--primary)' }} data-testid="enroll-btn">Enroll Now →</a>
        </div>
      </section>

      <section className="py-8 container text-center">
        <h2 style={{ marginBottom: '2rem' }}>📞 Contact Information</h2>
        <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h3 style={{ marginBottom: '1.5rem', color: 'var(--primary)' }}>Adhva Academy</h3>
          <div style={{ display: 'grid', gap: '1rem', textAlign: 'left' }}>
            <p><strong>Website:</strong> <a href="https://www.adhvaacademy.in" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)' }}>www.adhvaacademy.in</a></p>
            <p><strong>Email:</strong> <a href="mailto:adhvaacademy@gmail.com" style={{ color: 'var(--primary)' }}>adhvaacademy@gmail.com</a></p>
            <p><strong>WhatsApp:</strong> <a href="https://wa.me/918867198007" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)' }}>+91 88671 98007 / +91 88671 93007</a></p>
            <p><strong>Address:</strong> <a href="https://share.google/pTMB7aX8YZZOBxWJZ" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)' }}>Kuvempunagar, Mysuru</a></p>
          </div>
        </div>

        <div style={{ marginTop: '3rem', padding: '2rem', background: 'var(--secondary)', borderRadius: '8px', maxWidth: '800px', margin: '3rem auto 0' }}>
          <h3 style={{ marginBottom: '1rem', color: 'var(--primary)', fontSize: '1.5rem' }}>Building Strong Foundations for UPSC Success</h3>
          <p style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '1.5rem' }}>Enrollments Open for October 2025 Batch</p>
          <a 
            href="https://forms.gle/5mjmuxov7LaYCHTU6" 
            target="_blank"
            rel="noopener noreferrer"
            style={{ 
              display: 'inline-block',
              padding: '1rem 3rem',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: '#ffffff',
              borderRadius: '0.5rem',
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: '1.125rem',
              boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-3px) scale(1.05)';
              e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.6)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0) scale(1)';
              e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
            }}
          >
            🎯 Start Your UPSC Journey Today
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NCERTMasteryPage;
